import { render, staticRenderFns } from "./NewReturnReplace.vue?vue&type=template&id=79c8e9e2&scoped=true&"
import script from "./NewReturnReplace.vue?vue&type=script&lang=js&"
export * from "./NewReturnReplace.vue?vue&type=script&lang=js&"
import style0 from "./NewReturnReplace.vue?vue&type=style&index=0&id=79c8e9e2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79c8e9e2",
  null
  
)

export default component.exports